import { useMemo } from 'react'
import useQuery from './useQuery'

const useRegistratonPage = () => {
  const urlParams = useQuery()
  //check if admin is creating a client
  const is_admin_adding_client = useMemo(() => {
    if (urlParams.get('admin') == 1) {
    return true;
    }
    return false
  }, [urlParams])

  // admin creating a client
  const admin_url_param = useMemo(() => {
    return is_admin_adding_client ? '&admin=1' : ''
  }, [is_admin_adding_client])

  const registration_pending_user_url_param = useMemo(() => {
    const uid = urlParams.get('uid')
    if (uid) {
      return `&uid=${uid}`
    }
    return ''
  }, [urlParams])

  return [is_admin_adding_client, admin_url_param, registration_pending_user_url_param]
}

export default useRegistratonPage